import Vue from 'vue'
import ClubPlayerAnnouncement from '~/modules/club-player-announcement'

Vue.use(ClubPlayerAnnouncement)
